import React, { Component } from "react";
import { BrowserRouter as Router, Route, NavLink, Redirect, Switch } from "react-router-dom";

import { Navbar } from "react-bootstrap";

import "./App.css";
import "./StopsStyle.css";

import logo from "./Images/pkm_logo_long.png";

import {Topbar} from "./Topbar";

import Strzyza from "./TrainStops/Strzyza";
import Niedzwiednik from "./TrainStops/Niedzwiednik";
import Bretowo from "./TrainStops/Bretowo";
import Jasien from "./TrainStops/Jasien";
import Kielpinek from "./TrainStops/Kielpinek";
import Matarnia from "./TrainStops/Matarnia";
import Firoga from "./TrainStops/Firoga";
import PortLotniczy from "./TrainStops/PortLotniczy";
import Rebiechowo from "./TrainStops/Rebiechowo";


class App extends Component {
  

  closeNavbar() {
    const el = document.querySelector('.navbar-collapse');
    if (el.classList.contains('show')) {
      el.classList.remove('show')
    }
}

  render() {
    return (
      <Router className="general" basename="/przystanki">
        
        <Topbar />
        <Navbar expand="xl" className="d-flex justify-content-between menu">
          <a href="/">
            <img className="logo" src={logo} alt="Logo" />
          </a>
          <Navbar.Toggle/>
          <Navbar.Collapse>
            
            <NavLink onClick={this.closeNavbar} className="menu-link" to="/strzyza">
              Gdańsk Strzyża
            </NavLink>
            

            <NavLink onClick={this.closeNavbar} className="menu-link" to="/niedzwiednik">
              Gdańsk Niedźwiednik
            </NavLink>

            <NavLink onClick={this.closeNavbar} className="menu-link" to="/bretowo">
              Gdańsk Brętowo
            </NavLink>

            <NavLink onClick={this.closeNavbar} className="menu-link" to="/jasien">
              Gdańsk Jasień
            </NavLink>

            <NavLink onClick={this.closeNavbar} className="menu-link" to="/kielpinek">
              Gdańsk Kiełpinek
            </NavLink>

            <NavLink onClick={this.closeNavbar} className="menu-link" to="/matarnia">
              Gdańsk Matarnia
            </NavLink>

            <NavLink onClick={this.closeNavbar} className="menu-link" to="/firoga">
              Gdańsk Firoga
            </NavLink>

            <NavLink onClick={this.closeNavbar} className="menu-link" to="/port-lotniczy">
              Gdańsk Port Lotniczy
            </NavLink>

            <NavLink onClick={this.closeNavbar} className="menu-link" to="/rebiechowo">
              Gdańsk Rębiechowo
            </NavLink>
          </Navbar.Collapse>
        </Navbar>

        <Switch>
        <Route exact path="/"><Redirect to="/strzyza" /></Route>
        <Route path="/strzyza" component={Strzyza} />
        <Route path="/niedzwiednik" component={Niedzwiednik} />
        <Route path="/bretowo" component={Bretowo} />
        <Route path="/jasien" component={Jasien} />
        <Route path="/kielpinek" component={Kielpinek} />
        <Route path="/matarnia" component={Matarnia} />
        <Route path="/firoga" component={Firoga} />
        <Route path="/port-lotniczy" component={PortLotniczy} />
        <Route path="/rebiechowo" component={Rebiechowo} />
        </Switch>
        <Navbar fixed="bottom" className="footer">
          Pomorska Kolej Metropolitalna S.A. | Wszelkie Prawa Zastrzeżone
        </Navbar>
      </Router>
    );
  }
}

export default App;
